(function () {

  function initProductCards(scope = document) {
    scope.querySelectorAll('[data-product]').forEach((card) => {
      if (card.dataset.inited) return;
      card.dataset.inited = "true";

      const priceEl = card.querySelector('[data-price]');
      const textEl = card.querySelector('[data-variant-text]');
      const mainImg = card.querySelector('.img-main');
      const hoverImg = card.querySelector('.img-hover');
      const swatches = card.querySelectorAll('.custom_swatch');

      if (!priceEl || !textEl || swatches.length === 0) return;

      const original = {
        price: priceEl.textContent.trim(),
        text: textEl.textContent.trim(),
        main: mainImg?.src,
        hover: hoverImg?.src,
        url: card.dataset.productUrl || "",
        carat: card.querySelector('[data-value-carat]')?.textContent.trim() || '',
        grams: card.querySelector('[data-value-grams]')?.textContent.trim() || '',
        kt: card.querySelector('[data-value-kt]')?.textContent.trim() || '',
        caratDisplay: card.querySelector('[data-spec-carat]')?.style.display || '',
        gramsDisplay: card.querySelector('[data-spec-grams]')?.style.display || '',
        ktDisplay: card.querySelector('[data-spec-kt]')?.style.display || ''
      };

      let selected = null;

      function apply(swatch) {
        priceEl.textContent = swatch.dataset.price;
        textEl.textContent = swatch.dataset.text;
        if (swatch.dataset.main) mainImg.src = swatch.dataset.main;
        if (hoverImg && swatch.dataset.hover) hoverImg.src = swatch.dataset.hover;

        if (swatch.dataset.url) {
          card.dataset.productUrl = swatch.dataset.url;
          card.querySelectorAll('a.image-wrap, a.quick-cart, .product-title-link').forEach((link) => {
            link.href = swatch.dataset.url;
          });
        }
// Carat
        const caratEl = card.querySelector('[data-value-carat]');
        const caratContainer = card.querySelector('[data-spec-carat]');
        if (caratEl && caratContainer) {
          const newCarat = swatch.dataset.carat;
          if (newCarat && newCarat !== 'N/A' && newCarat.trim() !== '') {
            caratEl.textContent = newCarat + ' carats';
            caratContainer.style.display = 'flex';
          } else {
            caratContainer.style.display = 'none';
          }
        }

        // Grams
        const gramsEl = card.querySelector('[data-value-grams]');
        const gramsContainer = card.querySelector('[data-spec-grams]');
        if (gramsEl && gramsContainer) {
          const newGrams = swatch.dataset.grams;
          if (newGrams && newGrams !== 'N/A' && newGrams.trim() !== '') {
            gramsEl.textContent = newGrams + ' grams';
            gramsContainer.style.display = 'flex';
          } else {
            gramsContainer.style.display = 'none';
          }
        }

        // KT
        const ktEl = card.querySelector('[data-value-kt]');
        const ktContainer = card.querySelector('[data-spec-kt]');
        if (ktEl && ktContainer) {
          const newKt = swatch.dataset.kt;
          if (newKt && newKt !== 'N/A' && newKt.trim() !== '') {
            ktEl.textContent = newKt;
            ktContainer.style.display = 'flex';
          } else {
            ktContainer.style.display = 'none';
          }
        }
      }

      function reset() {
        if (selected) return apply(selected);
        priceEl.textContent = original.price;
        textEl.textContent = original.text;
        if (original.main) mainImg.src = original.main;
        if (hoverImg && original.hover) hoverImg.src = original.hover;

        if (original.url) {
          card.dataset.productUrl = original.url;
          card.querySelectorAll('a.image-wrap, a.quick-cart, .product-title-link').forEach((link) => {
            link.href = original.url;
          });
        }
// Restore specs
        const caratEl = card.querySelector('[data-value-carat]');
        const caratContainer = card.querySelector('[data-spec-carat]');
        if (caratEl && caratContainer) {
          caratEl.textContent = original.carat;
          caratContainer.style.display = original.caratDisplay || 'none';
        }

        const gramsEl = card.querySelector('[data-value-grams]');
        const gramsContainer = card.querySelector('[data-spec-grams]');
        if (gramsEl && gramsContainer) {
          gramsEl.textContent = original.grams;
          gramsContainer.style.display = original.gramsDisplay || 'none';
        }

        const ktEl = card.querySelector('[data-value-kt]');
        const ktContainer = card.querySelector('[data-spec-kt]');
        if (ktEl && ktContainer) {
          ktEl.textContent = original.kt;
          ktContainer.style.display = original.ktDisplay || 'none';
        }
      }

      swatches.forEach((swatch) => {
        swatch.addEventListener('mouseenter', () => apply(swatch));
        swatch.addEventListener('mouseleave', reset);
        swatch.addEventListener('click', (e) => {
          e.stopPropagation();
          swatches.forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
          selected = swatch;
          apply(swatch);
        });
      });

      swatches[0].classList.add('active');
      selected = swatches[0];
      apply(swatches[0]);
    });
  }

  // Make global
  window.initProductCards = initProductCards;

  // Auto-init on page load
  document.addEventListener('DOMContentLoaded', () => {
    initProductCards();
  });

  // Delegated click on product cards to open product page if clicking non-link/non-swatch areas
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-product]');
    if (!card) return;

    if (e.target.closest('.custom_swatch') || e.target.closest('.swatches')) return;
    if (e.target.closest('a')) return;

    const url = card.dataset.productUrl;
    if (url) {
      window.location.href = url;
    }
  });

})();
